import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function SEO({ title, description, image }) {
  const { pathname } = useLocation();
  const baseUrl = "https://www.suvengineers.com";
  const canonicalUrl = `${baseUrl}${pathname}`;
  const defaultImage = `${baseUrl}/assets/suvlogo.png`;

  useEffect(() => {
    // 1. Update Page Title
    if (title) {
      document.title = title;
    }

    // Helper to update or create meta tags
    const setMetaTag = (attrName, attrVal, contentVal) => {
      let meta = document.querySelector(`meta[${attrName}="${attrVal}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attrName, attrVal);
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", contentVal);
    };

    // Helper to update or create link tags
    const setLinkTag = (relVal, hrefVal) => {
      let link = document.querySelector(`link[rel="${relVal}"]`);
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", relVal);
        document.head.appendChild(link);
      }
      link.setAttribute("href", hrefVal);
    };

    // 2. Meta Description
    if (description) {
      setMetaTag("name", "description", description);
    }

    // 3. Open Graph Tags
    if (title) setMetaTag("property", "og:title", title);
    if (description) setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:image", image || defaultImage);
    setMetaTag("property", "og:url", canonicalUrl);
    setMetaTag("property", "og:type", "website");

    // 4. Twitter Card Tags
    setMetaTag("name", "twitter:card", "summary_large_image");
    if (title) setMetaTag("name", "twitter:title", title);
    if (description) setMetaTag("name", "twitter:description", description);
    setMetaTag("name", "twitter:image", image || defaultImage);

    // 5. Canonical Link
    setLinkTag("canonical", canonicalUrl);
  }, [title, description, image, canonicalUrl, defaultImage]);

  return null;
}
